import { render, staticRenderFns } from "./fixDocument.vue?vue&type=template&id=f320ed78&scoped=true&"
import script from "./fixDocument.vue?vue&type=script&lang=js&"
export * from "./fixDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f320ed78",
  null
  
)

export default component.exports